<template>
  <section>
    <form method="post" @submit.prevent="onSend" novalidate>
      <div class="modal-card" style="width: 860px">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            {{ formTitle }}
          </p>
        </header>
        <section class="modal-card-body">
          <form-wrapper :validator="$v.form">
            <form-group horizontal name="sort" :label="$t('attributes.sort')">
              <b-select v-model="form.sort" name="sort">
                <option
                  v-for="option in sortOptions"
                  :key="option"
                  :value="option"
                >
                  {{ option }}
                </option>
              </b-select>
            </form-group>
            <form-group
              horizontal
              name="status"
              attribute="attributes.status"
              :label="$t('attributes.status')"
            >
              <b-switch
                v-model="form.status"
                name="status"
                true-value="Y"
                false-value="N"
              ></b-switch>
            </form-group>
            <form-group horizontal name="name" :label="$t('attributes.name')">
              <b-input
                v-model="form.name"
                name="name"
                :placeholder="
                  $t('message.please_input') + $t('attributes.name')
                "
                expanded
              >
              </b-input>
            </form-group>
            <form-group
              horizontal
              name="picture"
              attribute="attributes.picture"
              :label="$t('attributes.picture')"
              grouped
            >
              <template #label>
                {{ $t('attributes.picture') }}
                <b-tooltip type="is-dark" label="1920*640/限定jpg檔，600KB內">
                  <b-icon size="is-small" icon="help-circle-outline"></b-icon>
                </b-tooltip>
              </template>
              <b-field class="file">
                <a class="button is-primary" @click="onSelectPictureImage">
                  <b-icon icon="upload"></b-icon>
                  <span>{{ $t('message.please_select_file') }}</span>
                </a>
                <p
                  v-if="form.picture"
                  class="tag is-warning"
                  style="margin-left: 4px; height: 40px"
                >
                  <a
                    :href="projectImageUrl(form.picture)"
                    @click.prevent="onClickImage(projectImageUrl(form.picture))"
                  >
                    {{ form.picture }}
                  </a>
                </p>
              </b-field>
            </form-group>
            <form-group
              horizontal
              name="mobile_picture"
              attribute="attributes.mobile_picture"
              :label="$t('attributes.mobile_picture')"
              grouped
            >
              <template #label>
                {{ $t('attributes.mobile_picture') }}
                <b-tooltip type="is-dark" label="480*320/限定jpg檔，600KB內">
                  <b-icon size="is-small" icon="help-circle-outline"></b-icon>
                </b-tooltip>
              </template>
              <b-field class="file">
                <a
                  class="button is-primary"
                  @click="onSelectMobilePictureImage"
                >
                  <b-icon icon="upload"></b-icon>
                  <span>{{ $t('message.please_select_file') }}</span>
                </a>
                <p
                  v-if="form.mobile_picture"
                  class="tag is-warning"
                  style="margin-left: 4px; height: 40px"
                >
                  <a
                    :href="projectImageUrl(form.mobile_picture)"
                    @click.prevent="
                      onClickImage(projectImageUrl(form.mobile_picture))
                    "
                  >
                    {{ form.mobile_picture }}
                  </a>
                </p>
              </b-field>
            </form-group>
            <form-group
              horizontal
              name="has_video"
              attribute="attributes.has_video"
              :label="$t('attributes.has_video')"
            >
              <b-switch
                v-model="form.has_video"
                name="has_video"
                true-value="Y"
                false-value="N"
              ></b-switch>
            </form-group>
            <form-group horizontal name="url" :label="$t('attributes.url')">
              <b-input
                v-model="form.url"
                name="url"
                :placeholder="$t('message.please_input') + $t('attributes.url')"
                expanded
              >
              </b-input>
            </form-group>
          </form-wrapper>
        </section>
        <footer class="modal-card-foot">
          <b-button class="is-fullwidth" @click="$parent.close()">
            {{ $t('attributes.close') }}
          </b-button>
          <b-button
            :loading="sending"
            type="is-primary"
            class="is-fullwidth"
            native-type="submit"
          >
            {{ this.isCreate ? $t('attributes.add') : $t('attributes.update') }}
          </b-button>
        </footer>
      </div>
    </form>
    <b-modal :active.sync="isImageModalActive">
      <p class="image">
        <img :src="selectedImageUrl" alt="" />
      </p>
    </b-modal>
  </section>
</template>

<script>
import { maxLength, required, requiredIf } from 'vuelidate/lib/validators'
import { OpenProjectFinder } from '@/utils/ckfinder'
import notifyService from '@/services/notifyService'

export default {
  name: 'HoneyMoonTopBannerForm',
  props: {
    banner: {
      type: Object,
      required: true
    },
    isCreate: {
      type: Boolean
    }
  },
  data() {
    return {
      sending: false,

      form: this.extractFormValues(this.banner),

      sortOptions: [...Array(20).keys()].map(i => i + 1),

      isImageModalActive: false,
      selectedImageUrl: null
    }
  },
  validations: {
    form: {
      sort: { required },
      status: { required },
      name: { required, maxLength: maxLength(50) },
      picture: { required },
      mobile_picture: { required },
      has_video: { required },
      url: {
        requiredIf: requiredIf(function(model) {
          return model.has_video
        }),
        maxLength: maxLength(200)
      },
      picture_alt: {}
    }
  },
  computed: {
    formTitle() {
      let title = !this.isCreate
        ? this.$t('attributes.modify')
        : this.$t('attributes.add')
      title += this.$t('attributes.honey_moon_page')
      title += this.$t('attributes.top_banner')
      return title
    }
  },
  watch: {
    banner(newBanner) {
      this.form = this.extractFormValues(newBanner)
    }
  },
  methods: {
    extractFormValues(data) {
      return {
        id: data.id,
        sort: data.sort,
        status: data.status,
        name: data.name,
        picture: data.picture,
        mobile_picture: data.mobile_picture,
        has_video: data.has_video,
        url: data.url
      }
    },
    async onSend() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }

      this.$emit('send', this.form)
    },
    async onSelectPictureImage() {
      try {
        this.form.picture = await OpenProjectFinder()
      } catch (e) {
        notifyService.error(e)
      }
    },
    async onSelectMobilePictureImage() {
      try {
        this.form.mobile_picture = await OpenProjectFinder()
      } catch (e) {
        notifyService.error(e)
      }
    },
    onClickImage(url) {
      this.isImageModalActive = true
      this.selectedImageUrl = url
    }
  }
}
</script>
